// 登录类型
export const LOGIN_TYPE_PWD = 0 // 密码登录
export const LOGIN_TYPE_MOB = 1 // 手机号登录

export const LOGIN_CROP_WZ = 'iwangzhe'
export const LOGIN_CROP_XS = 'xuanshang12'

export const MOBCODE_TYPE_SMS = 1    // 短信
export const MOBCODE_TYPE_VOICE = 2  // 语音验证码

// 第三方登录
export const OAUTH_PLAT_WEIBO = 1
export const OAUTH_PLAT_WEIXIN = 2
export const OAUTH_PLAT_QQ = 3
export const OAUTH_PLAT_HEXUN = 4
export const OAUTH_NAME_WEIBO = 'weibo'
export const OAUTH_NAME_WEIXIN = 'weixin'
export const OAUTH_NAME_QQ = 'qq'
export const OAUTH_NAME_HEXUN = 'hexun'
